import { CropperModal } from './components/CropperModal';
import Uploader from './components/Uploader';
import ErrorModals from './components/ErrorModals/ErrorModals';
import { TFileId, TLanguageIDs, TMediaFileType, IMaxFileSizeMBStyleSettings } from 'types';
import StyleSettingsImageUploaderState from './styleSettingsImageUploaderState/StyleSettingsImageUploaderState';
import React from 'react';

interface IStyleSettingsImageUploader {
	filePath: string | null;
	itemKey: string | null;
	horizontalAspectRatio?: number;
	verticalAspectRatio?: number;
	maxFileSizeMB?: IMaxFileSizeMBStyleSettings;
	translationId: string;
	languageId: TLanguageIDs;
	groupId: string;
	groupKey: string;
	isNeedImgHeading: boolean;
	mediaFileType: TMediaFileType;
	showGroupLoader: () => void;
	hideGroupLoader: () => void;
	groupLoading: boolean;
	isMakeImageRequest: boolean;
	setMediaSettingsFromNormalDisplay: (
		languageId: null | TLanguageIDs,
		groupId: string,
		translationId: string,
		mediaFileType: TMediaFileType,
		sourceUrl: string,
		fileId: TFileId,
	) => void;
	imageOrientation?: 'horizontal' | 'vertical';
	isDisabledControls?: boolean;
}

const StyleSettingsImageUploader: React.FC<IStyleSettingsImageUploader> = ({
	filePath,
	itemKey,
	translationId,
	isNeedImgHeading = false,
	imageOrientation,
	horizontalAspectRatio,
	verticalAspectRatio,
	maxFileSizeMB,
	mediaFileType,
	groupId,
	groupKey,
	languageId,
	isDisabledControls,
	showGroupLoader,
	hideGroupLoader,
	groupLoading,
	isMakeImageRequest,
	setMediaSettingsFromNormalDisplay,
}) => {
	const deleteFromNormalDisplayHandler = () => {
		setMediaSettingsFromNormalDisplay(languageId, groupId, translationId, mediaFileType, '', null);
	};

	return (
		<StyleSettingsImageUploaderState>
			<Uploader
				filePath={filePath}
				itemKey={itemKey}
				translationId={translationId}
				isNeedImgHeading={isNeedImgHeading}
				isDisabledControls={isDisabledControls}
				groupLoading={groupLoading}
				deleteFromNormalDisplayHandler={deleteFromNormalDisplayHandler}
				isMakeImageRequest={isMakeImageRequest}
			/>
			<CropperModal
				filePath={filePath}
				imageOrientation={imageOrientation}
				horizontalAspectRatio={horizontalAspectRatio}
				verticalAspectRatio={verticalAspectRatio}
				maxFileSizeMB={maxFileSizeMB}
				translationId={translationId}
				languageId={languageId}
				groupId={groupId}
				mediaFileType={mediaFileType}
				hasAbilityToUploadGif={['cards'].includes(groupKey)}
				showGroupLoader={showGroupLoader}
				hideGroupLoader={hideGroupLoader}
				setMediaSettingsFromNormalDisplay={setMediaSettingsFromNormalDisplay}
			/>
			<ErrorModals maxFileSizeMB={maxFileSizeMB} />
		</StyleSettingsImageUploaderState>
	);
};

export default StyleSettingsImageUploader;
